var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 0H6.875C3.07804 0 0 3.07804 0 6.875V37.125C0 40.922 3.07804 44 6.875 44H37.125C40.922 44 44 40.922 44 37.125V6.875C44 3.07804 40.922 0 37.125 0Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 33H11.275V18.2875H15.95V33ZM13.6125 16.225C12.1 16.225 11 15.125 11 13.6125C11 12.1 12.2375 11 13.6125 11C15.125 11 16.225 12.1 16.225 13.6125C16.225 15.125 15.125 16.225 13.6125 16.225ZM33 33H28.325V25.025C28.325 22.6875 27.3625 22 25.9875 22C24.6125 22 23.2375 23.1 23.2375 25.1625V33H18.5625V18.2875H22.9625V20.35C23.375 19.3875 25.025 17.875 27.3625 17.875C29.975 17.875 32.725 19.3875 32.725 23.925V33H33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4540f337015a11a469bb8b8092e848bd.svg";
export { ForwardRef as ReactComponent };